import PropTypes from 'prop-types';
import React from 'react';
import ScrollUp from '../Controls/ScrollUp';
import { Link } from 'react-router-dom';
import { i18n, i18nString } from '../../Utility/Format';
import moment from 'moment';

/**
 * This is the footer view for the application.
 */
const ApplicationFooter = (props) => {

    const thisYear = moment().format('YYYY');

    return (
        <footer className="application__footer">
            <div className="u-content">
                <a href="/#">{props.languageSelector}</a><span> | </span>
                <a href={i18nString('dmb.links.imprint.href', props.language)} target="_blank" rel="noopener noreferrer">
                    {i18n('dmb.links.imprint')} 
                </a><span> | </span>
                <Link to="/pages/terms-of-use">
                    {i18n('dmb.links.termsOfUse')}
                </Link><span> | </span>
                <Link to="/pages/privacy-statement">
                    {i18n('dmb.links.privacyStatement')}
                </Link>
                <br /><br />
            </div>
            <div className="u-content">
                <div className="u-float--left">
                    Copyright © 2005 - {thisYear}<br />
                    Deutsche Bank AG, Frankfurt am Main
                </div>
                <div className="u-float--right">
                    <ScrollUp />
                </div>
            </div>
            <div className="u-clearer"></div>
        </footer>
    );
};

ApplicationFooter.propTypes = {
    languageSelector: PropTypes.node.isRequired,
    language: PropTypes.string.isRequired
};

export default ApplicationFooter;